import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/IconShape.png'


const _hoisted_1 = { class: "adaptive-menu__header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "adaptive-menu-1"
}
const _hoisted_4 = { class: "nav-button" }
const _hoisted_5 = { class: "nav-button__profile" }
const _hoisted_6 = { class: "nav-button__profile__box" }
const _hoisted_7 = { class: "adaptive-oblos" }
const _hoisted_8 = {
  key: 0,
  class: "adaptivenav-select__body"
}
const _hoisted_9 = {
  href: "/Astana",
  class: "nav-select__decor"
}
const _hoisted_10 = { class: "nav-select__item" }
const _hoisted_11 = {
  href: "/Almaty",
  class: "nav-select__decor"
}
const _hoisted_12 = { class: "nav-select__item" }
const _hoisted_13 = {
  href: "/Shymkent",
  class: "nav-select__decor"
}
const _hoisted_14 = { class: "nav-select__item" }
const _hoisted_15 = {
  href: "/Akmola",
  class: "nav-select__decor"
}
const _hoisted_16 = { class: "nav-select__item" }
const _hoisted_17 = {
  href: "/Aktobe",
  class: "nav-select__decor"
}
const _hoisted_18 = { class: "nav-select__item" }
const _hoisted_19 = {
  href: "/almatyobl",
  class: "nav-select__decor"
}
const _hoisted_20 = { class: "nav-select__item" }
const _hoisted_21 = {
  href: "/atyrauobl",
  class: "nav-select__decor"
}
const _hoisted_22 = { class: "nav-select__item" }
const _hoisted_23 = {
  href: "/VKO",
  class: "nav-select__decor"
}
const _hoisted_24 = { class: "nav-select__item" }
const _hoisted_25 = {
  href: "/ZhambylObl",
  class: "nav-select__decor"
}
const _hoisted_26 = { class: "nav-select__item" }
const _hoisted_27 = {
  href: "/ZKO",
  class: "nav-select__decor"
}
const _hoisted_28 = { class: "nav-select__item" }
const _hoisted_29 = {
  href: "/Karaganda",
  class: "nav-select__decor"
}
const _hoisted_30 = { class: "nav-select__item" }
const _hoisted_31 = {
  href: "/Kostanay",
  class: "nav-select__decor"
}
const _hoisted_32 = { class: "nav-select__item" }
const _hoisted_33 = {
  href: "/Kyzylorda",
  class: "nav-select__decor"
}
const _hoisted_34 = { class: "nav-select__item" }
const _hoisted_35 = {
  href: "/Mangystau",
  class: "nav-select__decor"
}
const _hoisted_36 = { class: "nav-select__item" }
const _hoisted_37 = {
  href: "/Pavlodar",
  class: "nav-select__decor"
}
const _hoisted_38 = { class: "nav-select__item" }
const _hoisted_39 = {
  href: "/SKO",
  class: "nav-select__decor"
}
const _hoisted_40 = { class: "nav-select__item" }
const _hoisted_41 = {
  href: "/Turkystan",
  class: "nav-select__decor"
}
const _hoisted_42 = { class: "nav-select__item" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SwitchLanguage = _resolveComponent("SwitchLanguage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "nav-button__link",
        to: "/",
        exact: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, { name: "logoTRS" })
        ]),
        _: 1
      }),
      _createVNode(_component_SwitchLanguage),
      _createVNode("div", {
        class: "adaptive-menu-show",
        onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.toggleActiveButton(...args)))
      }, [
        _hoisted_2
      ])
    ]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.active)
          ? (_openBlock(), _createBlock("aside", _hoisted_3, [
              _createVNode("div", {
                class: "adaptive-close",
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.toggleActiveButton(...args)))
              }, [
                _createVNode(_component_SvgIcon, { name: "cancel" })
              ]),
              _createVNode("ul", _hoisted_4, [
                _createVNode("li", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    class: "nav-button__link",
                    to: _ctx.data.url,
                    exact: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_6, [
                        _createVNode(_component_SvgIcon, { name: "user_circle" }),
                        _createTextVNode(_toDisplayString(_ctx.data.name), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "nav-button__link",
                    to: "/",
                    exact: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        name: "Alt4",
                        class: "nav-button__icon"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.mainSystem')), 1 /* TEXT */)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "nav-button__link",
                    to: "/about-system",
                    exact: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        name: "Alt1",
                        class: "nav-button__icon"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.about')), 1 /* TEXT */)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "nav-button__link",
                    to: "/statistics",
                    exact: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        name: "Alt3",
                        class: "nav-button__icon"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.statistics')), 1 /* TEXT */)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", {
                  class: "oblost",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.activeOblost = !_ctx.activeOblost))
                }, [
                  _createVNode(_component_SvgIcon, {
                    name: "region",
                    class: "nav-button__icon"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.region')) + " ", 1 /* TEXT */),
                  _createVNode(_component_SvgIcon, {
                    name: "triangle-down",
                    class: "triangle-oblost"
                  }),
                  _createVNode("div", _hoisted_7, [
                    (_ctx.activeOblost)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          _createVNode("a", _hoisted_9, [
                            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('app.nur_sultan')), 1)
                          ]),
                          _createVNode("a", _hoisted_11, [
                            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('app.almaty')), 1)
                          ]),
                          _createVNode("a", _hoisted_13, [
                            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('app.shymkent')), 1)
                          ]),
                          _createVNode("a", _hoisted_15, [
                            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('app.aqmola')), 1)
                          ]),
                          _createVNode("a", _hoisted_17, [
                            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('app.aqtobe')), 1)
                          ]),
                          _createVNode("a", _hoisted_19, [
                            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('app.almatyObl')), 1)
                          ]),
                          _createVNode("a", _hoisted_21, [
                            _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('app.atyrau')), 1)
                          ]),
                          _createVNode("a", _hoisted_23, [
                            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('app.vko')), 1)
                          ]),
                          _createVNode("a", _hoisted_25, [
                            _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('app.jambyl')), 1)
                          ]),
                          _createVNode("a", _hoisted_27, [
                            _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('app.zko')), 1)
                          ]),
                          _createVNode("a", _hoisted_29, [
                            _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('app.karagandy')), 1)
                          ]),
                          _createVNode("a", _hoisted_31, [
                            _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('app.qostanai')), 1)
                          ]),
                          _createVNode("a", _hoisted_33, [
                            _createVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('app.qyzylorda')), 1)
                          ]),
                          _createVNode("a", _hoisted_35, [
                            _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('app.mangystau')), 1)
                          ]),
                          _createVNode("a", _hoisted_37, [
                            _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('app.pavlodar')), 1)
                          ]),
                          _createVNode("a", _hoisted_39, [
                            _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('app.sko')), 1)
                          ]),
                          _createVNode("a", _hoisted_41, [
                            _createVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('app.turkistan')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "nav-button__link",
                    to: "/create-report",
                    exact: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        name: "createareport",
                        class: "nav-button__icon"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.createReport')), 1 /* TEXT */)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "nav-button__link",
                    to: "/news",
                    exact: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        name: "Altnews",
                        class: "nav-button__icon"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.articles')), 1 /* TEXT */)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "nav-button__link",
                    to: "/faq",
                    exact: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        name: "Alt2",
                        class: "nav-button__icon"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.faq')), 1 /* TEXT */)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("li", null, [
                  (_ctx.logoutactive)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "adaptive-menu-logoout",
                        onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.logout(...args)))
                      }, [
                        _createVNode(_component_SvgIcon, {
                          name: "adaptiveexit",
                          class: "nav-button__icon"
                        }),
                        _createTextVNode(_toDisplayString(_ctx.$t('mobileTop.exit')), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
}